import { useIntl } from 'react-intl'
import { useParams } from 'react-router-dom'
import HistoryList from './HistoryList'
import { useGetOperationHistory } from '../../../hooks/useGetOperationHistory'
import { useHistoryItemRenderer } from './useHistoryItemRenderer'


const OperationHistory = ({ operationId }: any) => {
   const intl = useIntl()
   const { id } = useParams()
   const { data, status } = useGetOperationHistory({
      memberId: id || '',
      operationId,
      size: 10,
      page: 0,
   })
   const { renderItem } = useHistoryItemRenderer({ showChanges: true })

   return (
      <HistoryList
         title={intl.formatMessage({ id: 'partner.history.operation' })}
         items={data?.items || []}
         isLoading={status === 'pending'}
         emptyText={intl.formatMessage({ id: 'partner.history.operation.empty' })}
         renderItem={renderItem}
      />
   )
}

export default OperationHistory
